var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductsHubModule',{attrs:{"module-data":_vm.document,"data-luko-tracking":"Page-Products"}})}
var staticRenderFns = []

export { render, staticRenderFns }